// extracted by mini-css-extract-plugin
export default {"scoreContainer":"scoreContainer-Nj9O2","bgGray":"bgGray-S_eNq","basis":"basis-a9mx9","borderNone":"borderNone-oZSkj"};